import { EntityId } from '@reduxjs/toolkit';
import { useGetBlueprintProp } from './useGetBlueprintProp';

const nonCollectableTypes = ['Runestone', 'Moonstone'];

export const useShowCollectionSelector = (id: EntityId | undefined) => {
  const type = useGetBlueprintProp(id, 'type');
  return (type && !nonCollectableTypes.includes(type)) || false;
};
